// removed by extract-text-webpack-plugin
module.exports = {"base":"TextArea_base--25-gm","base__focused":"TextArea_base__focused--2dYyh","baseFocused":"TextArea_base__focused--2dYyh","base__placeholder":"TextArea_base__placeholder--jZwEW","basePlaceholder":"TextArea_base__placeholder--jZwEW","base__disabled":"TextArea_base__disabled--197CJ","baseDisabled":"TextArea_base__disabled--197CJ","wrapper":"TextArea_wrapper--1tvFA","textarea":"TextArea_textarea--tEZja","disabledStateOverlay":"TextArea_disabledStateOverlay--3ONb1"};


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/TextArea/TextArea.scss
// module id = 2329
// module chunks = 11